<template>
  <div id="app">
    <div class="preloader loader" style="display: none;">
      <img src="./assets/image/loader.gif" alt="#" />
    </div>
    <header>
      <div class="header-top">
        <div class="container">
          <div class="row">
            <div class="col-sm-12">
              <div class="top-right pull-right">
                <div id="top-links" class="nav pull-right">
                  <ul class="list-inline">
                    <li>
                      <a href="#/tagging"><i class="fa fa-tag"></i> Tagging</a>
                    </li>
                    <li>
                      <a href="#/Login"><i class="fa fa-user"></i> Login</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="header-inner">
          <div class="col-sm-4 col-xs-6 header-left">
            <div class="shipping">
              <div class="shipping-img"></div>
              <div class="shipping-text flex flex-col">
                <div>Free Shipping</div>
                <span class="shipping-detail">Free on all products</span>
              </div>
            </div>
          </div>
          <div class="col-sm-4 col-xs-6 header-middle">
            <div class="header-middle-top">
              <div id="logo">
                <a href="#/"
                  ><img
                    src="./assets/image/logo.png"
                    title="E-Commerce"
                    alt="E-Commerce"
                    class="img-responsive"
                /></a>
              </div>
            </div>
          </div>
          <div class="col-sm-4 col-xs-6 header-right">
            <div id="cart" class="btn-group btn-block">
              <button
                type="button"
                class="btn btn-inverse btn-block btn-lg dropdown-toggle cart-dropdown-button"
                @blur="documentClick"
              >
                <span id="cart-total"
                  >{{ basketData.length }} item(s) - $
                  {{ totalPrice | numeral("0,0") }}</span
                ><i class="fa fa-caret-down"></i>
              </button>
              <ul
                class="dropdown-menu pull-right cart-dropdown-menu"
                ref="dropdownMenu"
              >
                <li v-if="!basketData.length">
                  <p>No product in cart.</p>
                </li>
                <li v-for="(data, index) in basketData" :key="index">
                  <table class="table table-striped">
                    <tbody>
                      <tr>
                        <td class="text-center">
                          <a :href="'#/product/' + data.id"
                            ><img
                              class="img-thumbnail"
                              :title="data.name"
                              :alt="data.name"
                              :src="data.image[0]"
                          /></a>
                        </td>
                        <td class="text-left">
                          <a :href="'#/product/' + data.id">{{
                            $options.filters.limit(data.name, 30)
                          }}</a>
                        </td>
                        <td class="text-right">x {{ data.quantity }}</td>
                        <td class="text-right">
                          ${{ data.price | numeral(0, 0) }}
                        </td>
                        <td class="text-center">
                          <button
                            class="btn btn-danger btn-xs"
                            title="Remove"
                            type="button"
                            @click="removeBasket(data)"
                          >
                            <i class="fa fa-times"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </li>
                <li v-if="basketData.length">
                  <div>
                    <table class="table table-bordered">
                      <tbody>
                        <tr>
                          <td class="text-right"><strong>Total</strong></td>
                          <td class="text-right">
                            $ {{ totalPrice | numeral("0,0") }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <p class="text-right">
                      <span class="btn-viewcart"
                        ><a href="#/cart"
                          ><strong
                            ><i class="fa fa-shopping-cart"></i> View
                            Cart</strong
                          ></a
                        ></span
                      >
                      <span class="btn-checkout"
                        ><a href="#/checkout"
                          ><strong
                            ><i class="fa fa-share"></i> Checkout</strong
                          ></a
                        ></span
                      >
                    </p>
                  </div>
                </li>
              </ul>
            </div>
            <div id="search" class="input-group">
              <input
                type="text"
                name="search"
                value=""
                placeholder="Search"
                class="form-control input-lg"
              />
              <span class="input-group-btn">
                <button type="button" class="btn btn-default btn-lg">
                  <i class="fa fa-search"></i>
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>
    </header>

    <nav id="menu" class="navbar">
      <div class="nav-inner container">
        <div class="navbar-header">
          <span id="category" class="visible-xs">Categories</span>
          <button type="button" class="btn btn-navbar navbar-toggle">
            <i class="fa fa-bars"></i>
          </button>
        </div>
        <div class="navbar-collapse">
          <ul class="main-navigation">
            <li><a href="/" class="parent">Home</a></li>
            <li>
              <a
                href="javascript:void(0)"
                class="parent"
                @click="redirectPage('electronics')"
                >Electronics</a
              >
            </li>
            <li>
              <a
                href="javascript:void(0)"
                class="parent"
                @click="redirectPage('mobile')"
                >Mobile</a
              >
            </li>
            <li>
              <a
                href="javascript:void(0)"
                class="parent"
                @click="redirectPage('fashion')"
                >Fashion</a
              >
            </li>
            <li>
              <a
                href="javascript:void(0)"
                class="parent"
                @click="redirectPage('games')"
                >Games</a
              >
            </li>
            <li>
              <a
                href="javascript:void(0)"
                class="parent"
                @click="redirectPage('sports')"
                >Sports</a
              >
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <router-view :key="$route.fullPath" />

    <footer>
      <div class="container">
        <div class="footer-top-cms">
          <div class="footer-logo">
            <a href="#"
              ><img alt="index.html" src="./assets/image/logo-footer.png"
            /></a>
          </div>
          <div class="footer-desc">
            <span
              >Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat.
            </span>
          </div>
          <div class="footer-social">
            <h5>Social</h5>
            <ul>
              <li class="facebook">
                <a href="#"><i class="fa fa-facebook"></i></a>
              </li>
              <li class="linkedin">
                <a href="#"><i class="fa fa-linkedin"></i></a>
              </li>
              <li class="twitter">
                <a href="#"><i class="fa fa-twitter"></i></a>
              </li>
              <li class="gplus">
                <a href="#"><i class="fa fa-google-plus"></i></a>
              </li>
              <li class="youtube">
                <a href="#"><i class="fa fa-youtube-play"></i></a>
              </li>
            </ul>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-3 footer-block">
            <h5 class="footer-title">Information</h5>
            <ul class="list-unstyled ul-wrapper">
              <li><a href="about-us.html">About Us</a></li>
              <li><a href="checkout.html">Delivery Information</a></li>
              <li><a href="#">Privacy Policy</a></li>
              <li><a href="#">Terms &amp; Conditions</a></li>
            </ul>
          </div>
          <div class="col-sm-3 footer-block">
            <h5 class="footer-title">Customer Service</h5>
            <ul class="list-unstyled ul-wrapper">
              <li><a href="contact.html">Contact Us</a></li>
              <li><a href="#">Returns</a></li>
              <li><a href="#">Site Map</a></li>
              <li><a href="#">Wish List</a></li>
            </ul>
          </div>
          <div class="col-sm-3 footer-block">
            <h5 class="footer-title">Extras</h5>
            <ul class="list-unstyled ul-wrapper">
              <li><a href="#">Brands</a></li>
              <li><a href="gift.html">Gift Vouchers</a></li>
              <li><a href="affiliate.html">Affiliates</a></li>
              <li><a href="#">Specials</a></li>
            </ul>
          </div>
          <div class="col-sm-3 footer-block">
            <div class="content_footercms_right">
              <div class="footer-contact">
                <h5 class="contact-title footer-title">Contact Us</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
      <a id="scrollup">Scroll</a>
    </footer>
  </div>
</template>

<script>
import setCart from './mixins/setCart';

export default {
  name: "App",
  mixins: [setCart],
  data() {
    return {
      timer: null,
      basketData: JSON.parse(localStorage.getItem("basket")) || [],
      totalPrice: 0
    };
  },
  methods: {
    redirectPage(item) {
      this.$router.push("/category/" + item);
    },
    removeBasket(data) {
      const productId = data.id;
      const index = this.basketData.findIndex(function(o) {
        return o.id === productId;
      });
      if (index !== -1) {
        this.basketData.splice(index, 1);
      }
      localStorage.setItem("basket", JSON.stringify(this.basketData));

      Segmentify("basket:remove", {
        productId: data.id
      });

      /*dengage("sendDeviceEvent", "user_events", {
        event_type: "remove_basket",
        product_id: data.id,
        quantity: parseInt(data.quantity)
      });*/
      /*dataLayer.push({
        event: 'dengage_event',
        dengage_table_name: 'user_events',
        dengage_event_data: {
          event_type: "remove_basket",
          product_id: data.id,
          quantity: parseInt(data.quantity)
        }
      });*/
      dengage('ec:removeFromCart', {
        product_id: data.id,
        product_variant_id: '1',
        quantity: parseInt(data.quantity),
        unit_price: data.price,
        discounted_price: data.price,
        // ... shopping_cart_events tablosundaki ekstra kolonlar da olabilir
        cartItems: this.basketData.map(b => {
          return {
              product_id: b.id,
              product_variant_id: '1',
              quantity: b.quantity,
              unit_price: b.price,
              discounted_price: b.price,
              // ... shopping_cart_events_detail tablosundaki ekstra kolonlar da olabilir
          };
        }),
      });

      this.setCartForDengage();
      //collector.removeFromBasket(data.id, 1, parseInt(data.quantity), localStorage.getItem('basket_id'), localStorage.getItem('contact_key'));
    },
    documentClick(e) {
      var element = this.$refs.dropdownMenu;
      setTimeout(function() {
        element.style.display = "none";
      }, 200);
    }
  },
  created() {
    if ( ! localStorage.getItem('basket_id') ) {
      var basket_id = (Date.now().toString(36) + Math.random().toString(36).substr(2, 5)).toUpperCase();
      localStorage.setItem('basket_id', basket_id);
    }
    this.timer = setInterval(() => {
      const newVal = localStorage.getItem("basket");
      if (newVal !== this.basketData) {
        this.basketData = JSON.parse(newVal) || [];

        if (this.basketData) {
          var sum = 0;
          this.basketData.forEach(value => {
            var newPrice = value.price.replace(/[ ,.]/g, "");
            sum += parseInt(newPrice) * value.quantity;
          });
        }

        this.totalPrice = sum;

      }
    }, 1000);
    
    this.setCartForDengage();
  },
  beforeDestroy() {
    clearInterval(this.timer);
  }
};
</script>



// WEBPACK FOOTER //
// src/App.vue